module.exports = __webpack_public_path__ + "static/p-jakarta-kroasia-431787c7164ba2532842b82e96b3e12f.jpg";